/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Group_EmptyInputs */

const en_users_group_empty = /** @type {(inputs: Users_Group_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No groups found.`)
};

const pt_br2_users_group_empty = /** @type {(inputs: Users_Group_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum grupo encontrado.`)
};

/**
* | output |
* | --- |
* | "No groups found." |
*
* @param {Users_Group_EmptyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_group_empty = /** @type {((inputs?: Users_Group_EmptyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Group_EmptyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_group_empty(inputs)
	return pt_br2_users_group_empty(inputs)
});